export default "__VITE_ASSET__3a40a939__"